module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-user"
  }, [_c('div', {
    staticClass: "kp-modular-nav"
  }, [_c('name'), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-nav-right"
  }, [_c('ul', {
    staticClass: "kp-list-actions clearfix"
  }, [_c('export'), _vm._v(" "), _c('publish')], 1)])], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-51ef0ee8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/topbar/Main.vue
 ** module id = 827
 ** module chunks = 1
 **/